var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.27724 3.99999L8.93751 13.1654H14.6763C16.6845 13.1654 18.4979 11.964 19.2807 10.1147L19.8626 8.7401C20.1418 8.08074 19.6578 7.35026 18.9418 7.35026H7.21692",
    stroke: "#404554"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 4H4.77519C5.66505 4 6.44788 4.58792 6.69592 5.44251L8.9375 13.1655H14.6763C16.6845 13.1655 18.4979 11.964 19.2807 10.1147L19.8626 8.74011C20.1418 8.08075 19.6578 7.35027 18.9417 7.35027H7.21692",
    stroke: "#404554"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3845 20C11.2229 20 11.9026 19.3203 11.9026 18.4818C11.9026 17.6434 11.2229 16.9637 10.3845 16.9637C9.54604 16.9637 8.86633 17.6434 8.86633 18.4818C8.86633 19.3203 9.54604 20 10.3845 20Z",
    stroke: "#404554"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6194 15.6198H11.125C10.2164 15.6198 9.42189 15.0072 9.19077 14.1285L8.9375 13.1655L14.5226 13.1655",
    stroke: "#404554"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8232 20C17.6617 20 18.3414 19.3203 18.3414 18.4818C18.3414 17.6434 17.6617 16.9637 16.8232 16.9637C15.9848 16.9637 15.3051 17.6434 15.3051 18.4818C15.3051 19.3203 15.9848 20 16.8232 20Z",
    stroke: "#404554"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.2063bec2c07204948982901a9ecd5f22.svg";
export { ForwardRef as ReactComponent };